import { FC, useState } from "react";
import Spinner from "../spinner/Spinner";
import ErrorMessage from "../error-message";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../button";
import { FormControl, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import "./Search.scss";
import { Icon } from "common/components";

type SearchProps = {
  isDisable?: boolean;
  value: string;
  items?: string[];
  className?: string;
  hideClearButton?: boolean;
  onEnterOrSearchClick: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSelect?: (val: string) => void;
  isLoading?: boolean;
  errorMessage?: string;
  placeholder?: string;
  isEnableClear?: boolean;
  onClear?: () => void;
  isClearButtonFaint?: boolean;
};

const Search: FC<SearchProps> = ({
  isDisable = false,
  value,
  items = [],
  className = "",
  hideClearButton = false,
  onEnterOrSearchClick,
  onChange,
  onSelect,
  isLoading = false,
  errorMessage = "",
  placeholder = "Search...",
  isEnableClear,
  onClear,
  isClearButtonFaint = false
}: SearchProps) => {
  const [showClearIcon, setShowClearIcon] = useState("none");
  return (
    <FormControl>
      <div className="search_bar_wrap">
        <TextField
          className={`search-bar ${className}`}
          value={value}
          onChange={onChange}
          aria-label="Search"
          placeholder={placeholder}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onEnterOrSearchClick();
            }
          }}
          disabled={isDisable}
          autoComplete="one-time-code"
          InputProps={{
            // startAdornment: (
            //   <InputAdornment position='end'>
            //      <Icon src={<SearchIcon />} onClick={() => onEnterOrSearchClick()} />
            //   </InputAdornment>
            // ),
            endAdornment: (
              <>
                <InputAdornment position="end" onClick={() => onClear?.()}>
                  {isEnableClear && (
                    <Icon src={<CloseIcon />} onClick={() => onClear?.()} />
                  )}
                </InputAdornment>
                <InputAdornment position="end">
                  <Icon
                    src={<SearchIcon />}
                    onClick={() => onEnterOrSearchClick()}
                  />
                </InputAdornment>
              </>
            )
          }}
        />
        {/* <div className="search-bar__search-icon">
          <Icon src={<SearchIcon />} onClick={() => onEnterOrSearchClick()} />
        </div> */}
        {isLoading && (
          <div className="search-bar__spinner">
            <Spinner />
          </div>
        )}
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </div>
      {/* {isEnableClear && (
        <>
          <Button
            startIcon={<CloseIcon />}
            onClick={() => onClear?.()}
            className={
              isClearButtonFaint
                ? "search-bar__clear-faint"
                : "search-bar__clear-not-faint"
            }
          />
        </>
      )} */}
    </FormControl>
  );
};

export default Search;
